'use client'
import styles from "./styles.module.scss";
import { remark } from "remark";
import html from "remark-html";
import cn from "clsx";
import strapiSingleAttribute, { stripHtmlTags } from "@/api/strapiSingleAttribute";
import CommonButton from "@/components/common/Analytics/CustomButton";
import { GAEvent, GA_EVENTS } from "@/helpers/gaEvents";
import { ModalTypes } from "@/types/modal";
import Markdown from "@/components/atoms/Markdown";
import ShowImageOnViewPort from "@/helpers/ShowImageOnViewPort";
import { imgPathReplace } from "@/helpers/imgPathReplace";
import { useEffect, useState } from "react";


export default function BannerCard({
  BannerImage,
  isDesktop,
  CTA,
  Heading,
  enabled,
  ctaStyles,
  CN,
  children = null,
  showContent = false,
  hasLargeWidth = false,
  scrollToTop = false,
  sectionType = "",
  isGenericEvent = false,
  popup = {}
}: {
  BannerImage: any
  isDesktop: boolean
  CTA: {
    enabled: boolean
    text: string
    target: string
    title: string
    url: string
    modalType: ModalTypes
    associatedPrograms: Array<ProgramDetails>,
    isLandingPage: boolean,
    isLambdaAPI: boolean
  }
  Heading: any
  enabled: boolean
  ctaStyles?: any
  CN?: string
  children?: any
  showContent?: boolean
  hasLargeWidth?: boolean
  scrollToTop?: boolean
  sectionType?: string
  isGenericEvent?: boolean
  popup?: any
}) {
  if (!enabled) return null;
  const bannerImage = strapiSingleAttribute(BannerImage?.source);
  const bannerImageMobile =
    strapiSingleAttribute(BannerImage?.mobileSource) || bannerImage;
  const imageUrl = isDesktop ? bannerImage : bannerImageMobile;
  const { FOOTER_ENROLL_NOW, LEAD_INITIATE } = GAEvent;
  const [heading, setHeading] = useState('')

  const updateHeader = async () => {
    const newHeading = (await remark().use(html).process(Heading.text)).toString();
    setHeading(newHeading);
  };

  useEffect(() => {
    updateHeader();
  }, []);

  const headingText = stripHtmlTags(heading);

  return (
    <section className={cn("lg:my-[2.29rem]", CN)}>
      <div className={`container`}>
        <div className={`bg-blu ${styles.root}`}>
          <div
            className={cn(styles.content, {
              ["lg:!w-1/2"]: hasLargeWidth,
              [styles.leadershipContent]: showContent,
            })}
          >
         
                    {heading ? (
  <Markdown
    as="h2"
    className={cn(styles.title, `font-baskervville font-normal capitalize text-white`, {
      [styles.maxWidth85]: hasLargeWidth,
    })}
  >
    {heading.replace(/<\/?p[^>]*>/g, '')}
  </Markdown>
) : null}
            {CTA?.enabled ? (
                <div className={styles.cta}>
                  <CommonButton
                    isEventOnly={true}
                    GAData={!isGenericEvent ? GA_EVENTS.get(FOOTER_ENROLL_NOW):{}}
                    GADataNew={
                      isGenericEvent ? {
                        event: "generic_cta_click",
                        cta_text: CTA.text,
                        section_name: headingText ||  "NA",
                        isPageType: true,  
                    } :
                    {
                      ...GA_EVENTS.get(LEAD_INITIATE),
                      cta_text: CTA.text,
                      section_name: sectionType === "middle" ? "middle" : "footer",
                      header_title: headingText || "NA",
                      page_type: "Home Page",
                      page_url: true,
                    }
                   }
                   {
                    ...( !isGenericEvent && { 
                        onClickStorePayload: {
                         parentSection: sectionType === "middle" ? "middle" : "footer",
                         leadStartingCta : CTA.text
                        }
                      })
                    }
                    CTATarget={`${CTA.target}`}
                    type={CTA?.url === "#" ? "button" : "link"}
                    scroll={scrollToTop}
                    href={CTA.url}
                    modalType={CTA.modalType}
                    modalData={{ popup: popup, associatedPrograms: CTA.associatedPrograms, isLandingPage: CTA.isLandingPage, isNewLeadForm: true, isLambdaAPI: CTA.isLambdaAPI }}
                    className={styles.ctaBtn}
                    bg={ctaStyles?.bg || "o"}
                    color={ctaStyles?.color || "w"}
                    icon={ctaStyles?.icon || "/_a/icons/left-arrow-white.svg"}
                    hoverIcon={ctaStyles?.hoverIcon || "/_a/icons/left-arrow.svg"}
                    pageType="origin"
                  >
                    {CTA.text}
                  </CommonButton>
                </div>
            ) : null}
            {children}
          </div>
          {BannerImage.enabled ? (
            <div className={styles.bannerImageWrapper}>
              <ShowImageOnViewPort 
              className={styles.image}
               src={imgPathReplace(imageUrl?.url)} 
               srcset={imgPathReplace(imageUrl?.url)}
               alt={bannerImage?.alternativeText || "Amity Online"} 
               title={bannerImage?.alternativeText || "Amity Online"}
               width={isDesktop ? 600:388}
               height={isDesktop ? 320:178}
               loading="lazy"/>
            </div>
          ) : null}
        </div>
      </div>
    </section>
  );
}
